import React, { useState, useEffect } from 'react';
import { diagnostics } from '../utils/diagnostics';
import '../styles/pages.css';

const Diagnostics = () => {
  const [backendStatus, setBackendStatus] = useState(null);
  const [loginStatus, setLoginStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [demoAccountsStatus, setDemoAccountsStatus] = useState(null);

  const runDiagnostics = async () => {
    setLoading(true);
    try {
      // Check backend connection
      const backend = await diagnostics.checkBackendConnection();
      setBackendStatus(backend);

      if (backend.connected && backend.data?.demoAccounts) {
        setDemoAccountsStatus(backend.data.demoAccounts);
        
        // Test student login
        const studentLogin = await diagnostics.testLogin('GL-190', 'password');
        setLoginStatus(studentLogin);
      }
    } catch (error) {
      console.error('Diagnostic error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    runDiagnostics();
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-left">
        <div className="auth-card">
          <h1>System Diagnostics</h1>
          <p>Check if your GLA LMS is properly configured</p>

          <button 
            onClick={runDiagnostics} 
            className="btn btn-goldenrod" 
            disabled={loading}
            style={{ marginBottom: '2rem' }}
          >
            {loading ? 'Running diagnostics...' : 'Run Diagnostics'}
          </button>

          {backendStatus && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h3>Backend Status</h3>
              <div style={{
                padding: '1rem',
                borderRadius: '4px',
                backgroundColor: backendStatus.connected ? '#2d5016' : '#5c2626',
                color: '#fff',
                marginTop: '0.5rem'
              }}>
                <p><strong>Connected:</strong> {backendStatus.connected ? '✅ YES' : '❌ NO'}</p>
                <p><strong>Message:</strong> {backendStatus.message}</p>
                {backendStatus.data?.timestamp && (
                  <p><strong>Server Time:</strong> {backendStatus.data.timestamp}</p>
                )}
              </div>
            </div>
          )}

          {demoAccountsStatus && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h3>Demo Accounts</h3>
              <div style={{
                padding: '1rem',
                borderRadius: '4px',
                backgroundColor: '#1a3a2a',
                color: '#fff',
                marginTop: '0.5rem'
              }}>
                <p><strong>Student Account:</strong> {demoAccountsStatus.student ? '✅ Available' : '❌ Not Found'}</p>
                <p><strong>Instructor Account:</strong> {demoAccountsStatus.instructor ? '✅ Available' : '❌ Not Found'}</p>
              </div>
            </div>
          )}

          {loginStatus && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h3>Login Test (Student Account)</h3>
              <div style={{
                padding: '1rem',
                borderRadius: '4px',
                backgroundColor: loginStatus.success ? '#2d5016' : '#5c2626',
                color: '#fff',
                marginTop: '0.5rem'
              }}>
                <p><strong>Status:</strong> {loginStatus.success ? '✅ SUCCESS' : '❌ FAILED'}</p>
                <p><strong>Message:</strong> {loginStatus.message}</p>
                {loginStatus.data?.user && (
                  <p><strong>User:</strong> {loginStatus.data.user.email} ({loginStatus.data.user.role})</p>
                )}
              </div>
            </div>
          )}

          <div style={{
            padding: '1rem',
            borderRadius: '4px',
            backgroundColor: '#333',
            color: '#fff',
            fontSize: '0.9rem',
            fontFamily: 'monospace'
          }}>
            <h4 style={{ marginBottom: '0.5rem' }}>How to Fix Issues</h4>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>If Backend Status is "NO": Run both servers with `npm start` and `npm run frontend`</li>
              <li>If Demo Accounts show "Not Found": Run the setup script: `node backend/setupDemoAccount.js`</li>
              <li>If Login Test fails: Check server logs for error messages (see console)</li>
              <li>Demo credentials: <strong>GL-190</strong> / password (or instructor@example.com / password)</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="auth-right"></div>
    </div>
  );
};

export default Diagnostics;
